'use strict';

// ISSUE IF EMPTY

$(document).ready(function() {
  var variantId;
  var variantTitle;
  var initialVariantId;
  var notificationCallback;
  var notifyBusy = false;
  var acceptsMarketing = false;
  var productId = $('#pt-form-data').data('product-id');
  var firstUrl = window.location.href;
  var variantOnLoad = getParam('colour');
  var variantId = getParam('variant') || $('#pt-form-data').data('variant-id');//notification mail submission failed. workaround
  var $form = $('form.pt-form');

  // Disable Enter Submitting Product Form & Submit Email Notifier Instead
  $form.on('keydown', function(e) {
    if (e.keyCode === 13) {
      e.preventDefault();
      if (e.target.classList.contains('pt-product-notify-me-email')) {
        submitEmail();
      }
    }
  });

  // Enable The Accept Marketing Checkbox
  $('.pt-product-notify-me-checkmark').on('click', function(e) {
    e.preventDefault();
    $('.pt-product-notify-me-check-input').prop('checked', !$('.pt-product-notify-me-check-input').prop('checked'));
  });

  if (firstUrl.includes('?colour=')) {
    $('.variant-input').each(function() {
      // eslint-disable-next-line eqeqeq
      if ($(this).data('value') == variantOnLoad) {
        variantId = $(this).data('variant-id');
        variantTitle = $(this).data('value');
        if ($(this).data('material')) variantTitle += ' | ' + $(this).data('material');
      }
    });
  } else {
    $('.variant-input').each(function() {
      // eslint-disable-next-line eqeqeq
      if ($(this).data('variant-id') == 39666326306865 || $(this).data('variant-id') == variantId) { // swatch variant never has variant in querystring
        variantId = $(this).data('variant-id');
        variantTitle = $(this).data('value');
        if ($(this).data('material')) variantTitle += ' | ' + $(this).data('material');
      } 
    });
  }

  window.Swyft = window.Swyft;

  // Trigger Recommendations If Required
  initialVariantId = variantId;

  // Set Initial Trigger Global
  window.Swyft = window.Swyft || {};
  window.Swyft.PDPInitialTrigger = false;

  // On Load
  $(window).on('load', function() {
    if ($('#product-recommendations').length > 0) {
      window.jQuery('#product-recommendations ul').slick({
        infinite: false,
        arrows: false,
        dots: true,
        centerMode: true,
        slidesToShow: 4,
        responsive: [
          {
            breakpoint: 1200,
            settings: {
              slidesToShow: 2,
              centerMode: false
            }
          },
          {
            breakpoint: 768,
            settings: {
              slidesToShow: 1,
              centerMode: false
            }
          }
        ]
      });
      triggerRecommendations(initialVariantId);

      window.jQuery('.variant-input').on('click', function() {
        variantId = window.jQuery(this).data('variant-id');
        triggerRecommendations(variantId);
      });
    }
  });

  notificationCallback = function(data) {
    function oosPopupComplete(msg) {
      $('.pt-product-notify-me-email').val('');
      $('.pt-product-notify-me-button-label').text('Success');
      $('.pt-product-notify-me-message')
        .fadeIn(500)
        .text(msg);
      $('.pt-product-notify-me-message').css('color', '#38a254');
    }

    // eslint-disable-next-line block-scoped-var
    if (data.status === 'OK') {
      // GA Event Tracking
      if (typeof window.Swyft.Event === 'function') {
        // eslint-disable-next-line vars-on-top
        var datas = {};
        datas.title = $('#pt-form-data').data('product-title') ;+ ' | ' + jsUcfirst(variantTitle??'');
        datas.variant = variantId;
        window.Swyft.Event('emailwhenavailable', datas);
      }

      // eslint-disable-next-line vars-on-top
      var msgr = 'Success! You will be notified when the product is back in stock!';
      oosPopupComplete(msgr);
    } else if (data.errors.base !== undefined) {
      // eslint-disable-next-line vars-on-top
      var msgrr = data.errors.base[0];
      if (msgrr.includes('already registered')) {
        msgrr = 'Success! You will be notified when the product is back in stock!';
        oosPopupComplete(msgrr);
      }
    } else {
      // eslint-disable-next-line vars-on-top
      var msgrrr = 'Error please enter a correct email!';
      $('.pt-product-notify-me-message')
        .fadeIn(500)
        .text(msgrrr);
      $('.pt-product-notify-me-message').css('color', '#c33737');
    }
    notifyBusy = false;
    setTimeout(function() {
      $('.pt-product-notify-me-message')
        .text('')
        .hide();
      $('.pt-product-notify-me-button-label').text('Notify Me');
      $('.pt-product-notify-me-message').css('color', '#000000');
    }, 5000);
  };

  $('.pt-product-notify-me-button').on('click', function(e) {
    e.preventDefault();
    submitEmail();
  });

  $('.variant-input label').on('click', function() {
    if (!window.Swyft.PDPInitialTrigger) {
      window.Swyft.PDPInitialTrigger = true;
    } else {
      
    }
    variantId = $(this).parent().data('variant-id');
    triggerRecommendations();
  });

  // MTO Products don't add to cart on PDP when loading on specific PDP
  // However, add to bag works on MTO in PDP pop-up and collection page...
  // This fixes the error on PDP but really need to find out how the error happened
  $('#AddToCart-'+productId).on('click',function(e){
    e.preventDefault();

    var cartData = {
      items: [{ id: variantId, quantity: 1 }]
    };

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(cartData),
    }).then((response) => {
      $(this).find(".pt-form-add-to-cart-button-text").text("added to cart");
      window.location.replace('/cart');
    }).catch((error) => {
      console.log(error);
      return false;
    });
  });

  function submitEmail() {
    $('.pt-product-notify-me-message')
      .text('')
      .hide();
    if ($('.pt-product-notify-me-check-input').prop('checked') === true) {
      acceptsMarketing = true;
    }
    if (acceptsMarketing) {
      if ($('.pt-product-notify-me-email').val() === '') {
        $('.pt-product-notify-me-message')
          .fadeIn(500)
          .text('You must enter an email address')
          .css('color', '#c33737');
      } else if (!notifyBusy) {
        notifyBusy = true;
        // eslint-disable-next-line vars-on-top
        var email = $('.pt-product-notify-me-email').val();
        // eslint-disable-next-line no-undef
        if (typeof window.BIS === 'object') {
          window.BIS.create(email, variantId, productId, { accepts_marketing: acceptsMarketing }).then(notificationCallback);
        } else {
          // eslint-disable-next-line vars-on-top
          $('.pt-product-notify-me-message')
            .fadeIn(500)
            .text('Notify function still loading... Please wait')
            .css('color', '#c33737');
          bisLoadCheck();
        }
      }
    } else {
      $('.pt-product-notify-me-message')
        .fadeIn(500)
        .text('You must agree to receive notifications')
        .css('color', '#c33737');
    }
  }

  function getParam(name) {
    name = name.replace(/[\[]/, '\\[').replace(/[\]]/, '\\]');
    // eslint-disable-next-line vars-on-top
    var regex = new RegExp('[\\?&]' + name + '=([^&#]*)');
    // eslint-disable-next-line vars-on-top
    var results = regex.exec(window.location.search);
    return results === null ? '' : decodeURIComponent(results[1].replace(/\+/g, ' '));
  }

  function jsUcfirst(string) {
    return string.charAt(0).toUpperCase() + string.slice(1);
  }

  function bisLoadCheck() {
    setTimeout(function() {
      if (typeof window.BIS === 'object') {
        notifyBusy = false;
        $('.pt-product-notify-me-message')
          .fadeIn(500)
          .text('Notify function loaded and ready to use...')
          .css('color', '#38a254');
        setTimeout(function() {
          $('.pt-product-notify-me-message')
            .text('')
            .fadeOut(500);
        }, 2500);
      } else {
        bisLoadCheck();
      }
    }, 1000);
  }

  function triggerRecommendations(variantIdPassed) {
    if ($('#product-recommendations').length > 0) {
      window.jQuery('#product-recommendations .recommendation').hide();
      window.jQuery('.recommendation.variant-' + variantIdPassed).show();
      try {
        window.jQuery('.recommendation.variant-' + variantIdPassed + ' ul').slick('refresh');
      } catch (e) {}
    }
  }

    $(document).on("click", '[data-asset="view-fabrics"]', function(event) {
        event.stopPropagation();
        $(document).find('#btn-mto-modal').trigger('click');
    });

    $(document).on("click", '[data-asset="chat-to-specialist"]', function(event) {
        event.stopPropagation();
        var iframe = $(document).find('#chat-widget-minimized').contents();
        var button = $(iframe).find('button[type="button"]');
        if (button.length) {
            button.trigger('click');
        } else {
            console.log('Chat widget not found!.');
        }
    });
});
